import { Info } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { CostSimulationResponse } from '@/types/cost'
import { getCostReferenceNotes } from './costReferenceNoteTexts'

interface CostReferenceNotesProps {
  result: CostSimulationResponse
  className?: string
}

/**
 * 비용 상세 아래 보조 안내 (지침 §7.6).
 * 요양보호사 배치 미만 시설 참고 금액, 1·2등급 방문요양 중증 가산. 해당이 없으면 그리지 않는다.
 */
export default function CostReferenceNotes({ result, className }: CostReferenceNotesProps) {
  const notes = getCostReferenceNotes(result)
  if (notes.length === 0) return null

  return (
    <ul className={cn('flex flex-col gap-2 px-1', className)}>
      {notes.map((note) => (
        <li
          key={note.key}
          className="flex gap-1.5 text-caption leading-relaxed text-cb-gray-600"
        >
          <Info size={13} className="mt-0.5 flex-shrink-0" aria-hidden="true" />
          <span>{note.text}</span>
        </li>
      ))}
    </ul>
  )
}
